import script from "./SettingCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingCell.vue?vue&type=script&setup=true&lang=ts"

import "./SettingCell.vue?vue&type=style&index=0&id=db1ed008&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db1ed008"]])

export default __exports__